import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import { styled } from '@mui/styles';
import { TP_COLORS } from '../../../constants';

export const defaultButtonStyles = {
  padding: { xs: '6px 12px', sm: '12px 24px' },
};

const styledButtonProps = {
  borderRadius: '6px',
  fontWeight: 600,
  fontSize: '12px',
  backgroundColor: '#1E293B',
  color: '#F8FAFC',
  '&:hover': {
    backgroundColor: '#1E293B',
    color: '#F8FAFC',
  },
  '&.MuiLoadingButton-loading': {
    backgroundColor: TP_COLORS.border.color1,
  },
};

export const DarkLoadingButton = styled(LoadingButton)(styledButtonProps);

export const DarkButton = styled(Button)(styledButtonProps);

export default DarkLoadingButton;
